import card1Img from './Images/approach-1.webp';
import card2Img from './Images/approach-2.webp';
import card3Img from './Images/approach-3.webp';

export const approachCards = [
  {
    img: card1Img,
    title: "Freedom",
    text:
      "EduHub believes in freedom as the foundation of meaningful learning. By encouraging exploration, curiosity, and independent thinking, we empower learners to discover knowledge with confidence and purpose."
  },
  {
    img: card2Img,
    title: "Happiness",
    text:
      "At EduHub, happiness is central to the learning experience. We create a positive and supportive environment where joy in learning flourishes, nurturing emotional well-being alongside academic growth."
  },
  {
    img: card3Img,
    title: "Values",
    text:
      "Values form the core of EduHub’s philosophy. Along with academic excellence, we cultivate integrity, empathy, and respect, helping learners develop a strong moral foundation for life."
  }
];